import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-add-to-dictionary',
  templateUrl: './add-to-dictionary.component.html',
  styleUrls: ['./add-to-dictionary.component.scss']
})
export class AddToDictionaryComponent {

  @Input() word1: string = 'nanotubol';
  @Input() word2: string = 'nanotubes';


}
